import { render, staticRenderFns } from "./Prorate.vue?vue&type=template&id=f8abfffa&scoped=true&"
import script from "./Prorate.vue?vue&type=script&lang=js&"
export * from "./Prorate.vue?vue&type=script&lang=js&"
import style0 from "./Prorate.vue?vue&type=style&index=0&id=f8abfffa&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8abfffa",
  null
  
)

export default component.exports